import { pick } from "@styled-system/props";
import { formatPrice, SystemProps, Text } from "flicket-ui";

type PriceProps = SystemProps & {
  price: number;
  disableStrikeThrough?: boolean;
};

function Price({ price, disableStrikeThrough = false, ...props }: PriceProps) {
  const displayPrice = typeof price === "number" ? formatPrice(price) : "-";

  return (
    <Text
      as="span"
      {...pick(props)}
      className={disableStrikeThrough ? "" : "price"}
    >
      {displayPrice || "-"}
    </Text>
  );
}

export default Price;
